import type { PeriodType } from "@/apis/compare/types";

type PeriodLabelsLike = Partial<Record<string, string | null | undefined>>;

const DEFAULT_PERIOD_LABELS: Record<PeriodType, string> = {
  CURRENT: "당기",
  PREVIOUS: "전기",
  BEFORE_PREVIOUS: "전전기",
};

export const getPeriodLabel = (
  periodType: PeriodType,
  periodLabels?: PeriodLabelsLike | null,
): string => {
  const label = periodLabels?.[periodType]?.trim();
  return label || DEFAULT_PERIOD_LABELS[periodType] || periodType;
};
